import { bl_applet_client_side_perm_to_role_link_RowClass } from "blg-akaun-ts-lib";

export class ClientSidePermissionModel {
    bl_applet_client_side_perm_to_role_link: bl_applet_client_side_perm_to_role_link_RowClass = new bl_applet_client_side_perm_to_role_link_RowClass();
    ClientSidePermName: string;
    ClientSidePermCode: string;
    RoleName: string
}
